import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import {PropostaModule} from './proposta/proposta.module';

import {AmontrealComponent} from './a-montreal/a-montreal.component';
import {ComoFuncionaComponent} from './como-funciona/como-funciona.component';
import {ContatosComponent} from './contatos/contatos.component';
import {DestinosComponent} from './destinos/destinos.component';
import {DetalhesDestinosComponent} from './detalhes-destinos/detalhes-destinos.component';
import {DetalhesHotelComponent} from './detalhes-hotel/detalhes-hotel.component';
import {FacaParteComponent} from './proposta/faca-parte/faca-parte.component';
import {HomeComponent} from './home/home.component';
import {HoteisComponent} from './hoteis/hoteis.component';
import {IndiqueEGanheComponent} from './indique-e-ganhe/indique-e-ganhe.component';
import {LandingComponent} from './landing/landing.component';
import {LandingPermanenteComponent} from './landing-permanente/landing-permanente.component';
import {ListaHoteisComponent} from './lista-hoteis/lista-hoteis.component';
import {OnboardingEntranceComponent} from './onboarding-entrance/onboarding-entrance.component';
import {OnboardingVerificacaoComponent} from './onboarding-verificacao/onboarding-verificacao.component';
import {PerguntasFrequentesComponent} from './perguntas-frequentes/perguntas-frequentes.component';
import {PlanosComponent} from './planos/planos.component';
import {PoliticaPrivacidadeComponent} from './politica-privacidade/politica-privacidade.component';
import {SingleHotelComponent} from './single-hotel/single-hotel.component';
import {VantagensComponent} from './vantagens/vantagens.component';
import {MobilePropostaModule} from './proposta/mobile/mobile.proposta.module';
import { OrderModule } from '../views/order/order.module';

@NgModule({
	imports: [
		PropostaModule,
		SharedModule,
		MobilePropostaModule,
		OrderModule,
	],
    declarations: [
        AmontrealComponent,
        ComoFuncionaComponent,
        ContatosComponent,
        DestinosComponent,
        DetalhesDestinosComponent,
        DetalhesHotelComponent,
        FacaParteComponent,
        HomeComponent,
        HoteisComponent,
        IndiqueEGanheComponent,
        LandingComponent,
        LandingPermanenteComponent,
        ListaHoteisComponent,
        OnboardingEntranceComponent,
        OnboardingVerificacaoComponent,
        PerguntasFrequentesComponent,
        PlanosComponent,
        PoliticaPrivacidadeComponent,
        SingleHotelComponent,
        VantagensComponent,
    ],
    exports: [
        AmontrealComponent,
        ComoFuncionaComponent,
        ContatosComponent,
        DestinosComponent,
        DetalhesDestinosComponent,
        DetalhesHotelComponent,
        FacaParteComponent,
        HomeComponent,
        HoteisComponent,
        IndiqueEGanheComponent,
        LandingComponent,
        LandingPermanenteComponent,
        ListaHoteisComponent,
        OnboardingEntranceComponent,
        OnboardingVerificacaoComponent,
        PerguntasFrequentesComponent,
        PlanosComponent,
        PoliticaPrivacidadeComponent,
        PropostaModule,
        SingleHotelComponent,
        VantagensComponent,
    ]
})

export class PagesModule {}
